import { useCallback } from 'react';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';

export const useGoBack = () => {
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return { handleGoBack };
};
